import { configureStore } from "@reduxjs/toolkit";

import appReducer from "./app.slice";
import restaurantReducer from "./pages/restaurant/restaruant.slice";
import temperatureReducer from "./pages/temperatures/temperature.slice";
import { apiService } from "./app.service";


export const store = configureStore({
  reducer: {
    app: appReducer,
    [apiService.reducerPath]: apiService.reducer,
    restaurant: restaurantReducer,
    temperature: temperatureReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiService.middleware), // Only apiService middleware, NO labelApi.middleware
});